import React from 'react'
import PropTypes from 'prop-types'

export const TechStack = ({ techstack }) => {
    if (!techstack) return null;

    return (
        <div className="mt-6 pt-6 border-t border-gray-100">
            <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">Technologies</div>
            <ul className="flex flex-wrap gap-2">
                {techstack.map((tech, index) => (
                    <li key={index}>
                        <a
                            href={tech.URL}
                            rel="nofollow"
                            target="_blank"
                            className="px-3 py-1 text-xs font-medium text-primary-700 bg-primary-50 rounded-full border border-primary-200 hover:bg-primary-100 hover:border-primary-300 transition-colors"
                        >
                            {tech.name}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
}

const Experience = props => {
    return (
        <div className="w-full px-6 md:px-12 py-12 bg-gray-50/50" id="experience">
            <div className="w-full mx-auto">
                {/* Header aligned with content start */}
                <div className="mb-12 relative pl-4 border-l-4 border-primary-500">
                    <h4 className="text-sm font-bold tracking-widest text-primary-600 uppercase mb-2 font-sans">MY JOURNEY</h4>
                    <h1 className="text-4xl md:text-5xl font-bold text-gray-900 font-display">Work Experience</h1>
                </div>

                <div className="relative">
                    {/* Vertical Line - Aligned with Header Border (approx left-0) */}
                    <div className="absolute left-[1.5px] top-0 bottom-0 w-0.5 bg-gray-200"></div>

                    <ul className="space-y-12 list-none">
                        {props.children}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export const ExperienceItem = props => {
    return (
        <li className="relative pl-8 md:pl-12">
            {/* Timeline Dot - Centered on the line at left-[1.5px] */}
            <div className="absolute left-[-5px] top-6 md:top-8 w-4 h-4 rounded-full bg-primary-500 border-[3px] border-white z-10 box-content shadow-md"></div>

            {/* Content Card */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-8 hover:shadow-md transition-shadow duration-300 group">
                <div className="flex flex-col md:flex-row md:items-start justify-between gap-4 mb-6">
                    <div className="flex items-center gap-4">
                        <div className="w-16 h-16 rounded-xl bg-gray-50 p-2 border border-gray-100 flex items-center justify-center flex-shrink-0">
                            <img src={props.logo} alt={props.title} className="max-w-full max-h-full object-contain" />
                        </div>
                        <div>
                            <h3 className="text-xl md:text-2xl font-bold text-gray-900 font-display group-hover:text-primary-600 transition-colors">
                                {props.title}
                            </h3>
                            <div className="text-gray-600 font-medium mt-1">
                                {props.designation}
                            </div>
                        </div>
                    </div>
                    {/* Date Label - Visible on all screens now */}
                    <span className="inline-flex items-center px-4 py-1.5 rounded-full bg-gray-100 text-gray-600 text-sm font-semibold whitespace-nowrap self-start md:self-center">
                        {props.timeline}
                    </span>
                </div>

                <div className="prose prose-sm md:prose-base text-gray-600 max-w-none mb-6">
                    {props.children}
                </div>

                {props.projectImage && (
                    <div className="mt-6 mb-6 rounded-xl overflow-hidden border border-gray-100 shadow-sm">
                        <img src={props.projectImage} alt={props.title} className="w-full h-auto transform hover:scale-105 transition-transform duration-500" />
                    </div>
                )}

                <TechStack techstack={props.techstack} />
            </div>
        </li>
    );
}

Experience.propTypes = {
    children: PropTypes.node
}

export default Experience
